export type SizeInputType = {
  width: number | string;
  height: number | string;
};

/**
 *
 * @param strNumArg
 * @returns
 */
export const isStrNumErr = (strNumArg: string | number) => {
  let flag = false;

  if (strNumArg === "") {
    flag = true;
  }

  if (typeof strNumArg === "number" && (strNumArg < 256 || strNumArg > 4096)) {
    flag = true;
  }

  if (
    typeof strNumArg === "string" &&
    (parseInt(strNumArg) < 256 || parseInt(strNumArg) > 4096)
  ) {
    flag = true;
  }

  return flag;
};
